import React from 'react'
import FeatureDocumentation from '../../components/layouts/docsection'
import PayoutPage from "../../images/payoutPage.png"

const PayoutRequest = () => {
  const PayoutRequestDocs = {
    title: "Payout Request Management",
    description: "Efficiently manage and process payout requests with our streamlined system.",
    sections: [
      {
        title: "Overview",
        content:
          "Our payout request system enables easy verification and management of reseller payout requests. The verification process ensures that each request aligns with the account balance and originates from actual sales, not top-ups. Tendo administrators can approve or decline these requests based on predefined criteria.",
        image: PayoutPage,
        imageAlt: "Payout Request Dashboard Overview",
        imageCaption: "Figure 1: Comprehensive view of the Payout Request Dashboard",
      },
      {
        title: "Updating Request Status",
        content:
          "Efficiently update the status of payout requests from pending to either approved or declined. This process is essential for maintaining transparency and ensuring timely payments to resellers.",
        image: "/api/placeholder/800/400", // Replace with actual image path
        imageAlt: "Payout Status Update Interface",
        imageCaption: "Figure 2: Interface for updating payout request statuses",
        steps: [
          "Access the Payout Requests section in your admin dashboard.",
          "Locate the specific payout request you wish to update.",
          "Click on the 'Update Status' button associated with the request.",
          "In the status update modal, select either 'Approved' or 'Declined'.",
          "If necessary, provide a reason for the status change in the designated field.",
          "Review the changes and click 'Confirm' to update the status.",
        ],
        note: "Important: Ensure you have the necessary administrative privileges to modify payout request statuses. Always double-check the request details before confirming any status changes.",
      },
    ],
  };
  
  return <FeatureDocumentation {...PayoutRequestDocs} />
};

export default PayoutRequest;